// lib/runtime-keys.mjs のブラウザ代替。ブラウザ完結版では利用者キーは localStorage に直接置かれ、
// llm-client の resolveOpenRouterKey / resolveMeshyKey がここ経由で取得する。既存キー名を踏襲。
const STORE = { openrouter: 'vn-api-key-openrouter', meshy: 'vn-api-key-meshy' };
const MODEL_SETTINGS_STORE = 'vn-openrouter-model-settings-v1';
const MODEL_ID_KEYS = ['analysis', 'json', 'imageCost', 'imageSpeed', 'imageAdult'];
const IMAGE_ROLES = ['imageCost', 'imageSpeed', 'imageAdult'];

export function isValidOpenRouterModelId(value) {
    return typeof value === 'string'
        && value.length <= 200
        && /^[A-Za-z0-9][A-Za-z0-9._-]*\/[A-Za-z0-9][A-Za-z0-9._:-]*$/.test(value);
}

export function normalizeRuntimeModelSettings(value, { strict = false } = {}) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        if (strict) throw new Error('OpenRouter モデル設定はオブジェクトで指定してください');
        return {};
    }
    const out = {};
    for (const key of MODEL_ID_KEYS) {
        if (value[key] === undefined || value[key] === null || value[key] === '') continue;
        const model = typeof value[key] === 'string' ? value[key].trim() : '';
        if (!isValidOpenRouterModelId(model)) {
            if (strict) throw new Error(`${key} のモデルIDが不正です（例: deepseek/deepseek-v4-flash-0731）`);
            continue;
        }
        out[key] = model;
    }
    if (value.imageActiveRole !== undefined && value.imageActiveRole !== null && value.imageActiveRole !== '') {
        if (!IMAGE_ROLES.includes(value.imageActiveRole)) {
            if (strict) throw new Error('画像生成の使用候補が不正です');
        } else {
            out.imageActiveRole = value.imageActiveRole;
        }
    }
    return out;
}

/** ブラウザ版ではヘッダ由来のランタイム注入は無いため no-op（キーは localStorage が単一情報源）。 */
export function setRuntimeKeys() {
    /* no-op: localStorage が唯一の保存先 */
}

/** @param {'openrouter'|'meshy'} service */
export function getRuntimeKey(service) {
    try {
        const v = (localStorage.getItem(STORE[service]) ?? '').trim();
        return v !== '' ? v : null;
    } catch {
        return null;
    }
}

/** ブラウザ版は localStorage が単一の正本。 */
export function getRuntimeModelSettings() {
    try {
        return normalizeRuntimeModelSettings(JSON.parse(localStorage.getItem(MODEL_SETTINGS_STORE) ?? '{}'));
    } catch {
        return {};
    }
}

export function setRuntimeModelSettings(value) {
    localStorage.setItem(MODEL_SETTINGS_STORE, JSON.stringify(normalizeRuntimeModelSettings(value, { strict: true })));
}
